import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography, CircularProgress } from '@mui/material';
import PublicHeader from '../../Components/Header/PublicHeader';
import SiteFooter from '../../Components/Footer/SiteFooter';

const Logout: React.FC = () => {
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = () => {
    setIsLoggingOut(true);

    // ログイン画面へ引き継ぐため、クリア前に storeClerkId を取得しておく
    const storeClerkId = localStorage.getItem('clerk_id');

    // localStorage の全情報をクリア
    localStorage.clear();

    // storeClerkId があればクエリパラメータとしてログイン画面に渡す
    if (storeClerkId) {
      navigate(`/login?storeClerkId=${encodeURIComponent(storeClerkId)}`);
    } else {
      navigate('/login');
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <PublicHeader />
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 3,
          padding: 2,
        }}
      >
        <Typography variant="h5" component="h1">
          ログアウト
        </Typography>
        <Typography variant="body1" color="text.secondary" textAlign="center">
          ログアウトすると、この端末に保存されたログイン情報がすべて削除されます。
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handleLogout}
          disabled={isLoggingOut}
          startIcon={isLoggingOut ? <CircularProgress size={20} color="inherit" /> : undefined}
        >
          {isLoggingOut ? 'ログアウト中...' : 'ログアウトする'}
        </Button>
      </Box>
      <SiteFooter />
    </Box>
  );
};

export default Logout;
